<template>
  <button
    :class="['button', 'is-primary', 'is-fullwidth', { 'is-loading': loading }]"
    @click="createOnDemandSession(field)"
  >
    {{ buttonText }}
  </button>
</template>

<script>
import VisuwellService from "../../services/VisuwellService";
import InterviewsService from "@/services/InterviewsService";
import { redirectToVisuwell } from "../../helpers/visuwell";

export default {
  name: "OnDemandButton",

  props: {
    question: Object,
    buttonText: String,
    organizationLocationId: Number
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    answers() {
      return this.$store.state.interview.answers;
    },
    interviewId() {
      return this.$store.state.interview.id;
    },
    patientQueueId() {
      return this.$store.state.interview.patientQueue.id;
    },
    referrer() {
      return this.$store.getters["interview/getReferrer"];
    },
    patient() {
      return this.$store.getters["interview/getPatient"];
    },
    visuwellUser() {
      return this.$store.getters["interview/visuwellUser"];
    }
  },

  methods: {
    createOnDemandSession(field) {
      this.loading = true;

      let organizationLocationId = this.visuwellUser.organizationLocationId
        ? this.visuwellUser.organizationLocationId
        : this.organizationLocationId;

      let onDemandQuestionId = this.question ? this.question.id : null;

      VisuwellService.startOnDemandSession(this.interviewId, {
        patientQueueId: this.patientQueueId,
        organizationLocationId: organizationLocationId
      })
        .then(data => {
          window.DD_LOGS &&
            DD_LOGS.logger.info("started ondemand session", data.attributes);
          if (data.attributes && data.attributes.jwt) {
            let onDemandSession = data.attributes;
            onDemandSession["id"] = data.id;
            InterviewsService.finish(
              this.interviewId,
              this.patientQueueId,
              this.answers,
              {
                referrer: this.referrer,
                patient: this.patient
              },
              onDemandSession,
              null,
              onDemandQuestionId
            )
              .then(({ submitted }) => {
                let onDemandJwt = data.attributes.jwt;
                let onDemandRedirect = data.attributes["on-demand-redirect"];

                if (submitted) {
                  VisuwellService.login(onDemandJwt, onDemandRedirect).then(
                    redirectToVisuwell
                  );
                } else {
                  this.loading = false;
                  this.message =
                    "Sorry, we could not submit your appointment request. Please try again.";
                }
              })
              .catch(error => {
                this.loading = false;
                this.message = `Sorry, we could not submit your appointment request. ${
                  error.response.data.errors[0].detail
                }`;
              });
          } else {
            alert("Something went wrong.");
          }
        })
        .catch(error => {
          this.loading = false;
          alert(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
